<template>
    <div id="app">
        <template v-if="$root.embed">
            <router-view :key="$route.path" :class="{embeded: $root.embed}" />
        </template>
        <template v-else>
            <component :is="layout">
                <router-view :key="$route.path" />
            </component>
        </template>

        <oc-loader v-if="showLoader || $store.getters['auth/isLoading']" :backdrop="false" :transparent="true" size="big">
            <div class="text-center pt-2 pb-2">
                <div class="spinner-grow spinner-grow-sm text-primary" role="status" />
                <div class="spinner-grow spinner-grow-sm text-primary" role="status" />
                <div class="spinner-grow spinner-grow-sm text-primary" role="status" />
            </div>
        </oc-loader>
    </div>
</template>

<script>
import DefaultLayout from "@/layout/DefaultLayout"
import AppLayout from "@/layout/AppLayout"

import { EventBus } from '@framework'

export default {
    name: "App",
    components: {
        DefaultLayout,
        AppLayout
    },
    data() {
        return {
            showLoader: false
        }
    },
    computed: {
        layout() {
            if( this.$route.meta.layout ){
                return this.$route.meta.layout + '-layout'
            }

            if( ! this.$root.isGuest ) {
                return 'app-layout'
            }

            return 'default-layout'
        }
    },
    created() {

        EventBus.$on('show-loader', () => {
            this.showLoader = true
        })

        EventBus.$on('hide-loader', () => {
            this.showLoader = false
        })

        // register flash messages
        for (let type in _appConfig.flashMessages)
        {
            let message = _appConfig.flashMessages[type]

            if( isArray(message) ) {
                for (let i in message)
                {
                    app.$addFlashMessage(message[i], type, 1)
                }
            } else {
                app.$addFlashMessage(message, type, 1)
            }
        }
    }
}
</script>
